import React from "react";
import { Box, Fade, Snackbar } from "@mui/material";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

interface Props {
  message: string;
  open: boolean;
  type: "success" | "error" | "info";
  handleClose: () => void;
  warningText?: boolean;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={10} ref={ref} variant="filled" {...props} />;
});

const Toast: React.FC<Props> = (props) => {
  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={props.open}
        autoHideDuration={5000}
        onClose={props.handleClose}
        TransitionComponent={Fade}
        sx={{
          marginTop: 6,
        }}
      >
        <Alert
          onClose={props.handleClose}
          severity={props.type}
          variant="standard"
          sx={{ width: "100%" }}
        >
          {props.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Toast;
